/**
 * @param {import('vue-router').NavigationGuardNext} next - The next() function from Vue-Router
 * @param {string} url - The URL to check
 * @returns {void} - A next route
 */
export default function redirectToLogin(next, url) {
	const routesToFilterOut = ['/', '/login', '/404', '/403']
	if (routesToFilterOut.includes(url)) {
		return next({ path: '/login' }) // Redirect to /login
	} else {
		return next({ path: '/login', query: { r: url } }) // Redirect to /login with a redirect parameter
	}
}
